export const STANDARD_BRANCH = 'standard'
export const NONE = 'none'
